import React from 'react';
import { Grid, Typography } from '@mui/material';
import PolarisIcon from '@/components/_common/PolarisIcon';
import { Dialog } from '@/components/_common';
import { TimelineItem } from '@/redux/slices/packagingSlice.types';
import EditorOption from '@/components/Packaging/common/EditorOption';

interface Props {
  open: boolean;
  itemsToBeRemoved: TimelineItem[];
  onSubmit: () => void;
  onCancel: () => void;
}

const SwapTemplateConfirmationDialog: React.FC<Props> = ({ open, itemsToBeRemoved, onSubmit, onCancel }) => {
  return (
    <Dialog
      titleIcon={<PolarisIcon icon="settings" height={18} style={{ marginRight: 8 }} />}
      open={open}
      onSubmit={onSubmit}
      onCancel={onCancel}
      title="Confirm Template Swap"
      submitText="Confirm"
    >
      <Grid container direction="column" spacing={2} alignItems={'center'} justifyContent={'center'}>
        <Grid item sx={{ width: '60%', textAlign: 'center' }}>
          <Typography variant="body1" sx={{ fontSize: '1.4rem', opacity: 0.7 }}>
            The following cut type{itemsToBeRemoved.length > 1 ? 's' : ''} will be removed if this template is used. Do you still want to proceed?
          </Typography>
        </Grid>
        <Grid item sx={{ width: 400 }}>
          {itemsToBeRemoved.map(({ kind, label }, index) => (
            <EditorOption key={index} kind={kind} label={label} toBeRemoved />
          ))}
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default SwapTemplateConfirmationDialog;
